<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="false"
      :multiple="false"
      thema="label"
      title="안전활동사항"
      :tableData="[
        {
          id: 'label',
          title: '이행사항',
          type: 'label',
          align: 'left',
          vertical: 'middle',
        },
        {
          id: 'input1',
          title: '세부내용',
          type: 'string',
          align: 'left',
          vertical: 'middle',
        },
        {
          id: 'input2',
          title: '점검일시',
          type: 'dateArr',
          vertical: 'middle',
        },
        {
          id: 'input3',
          title: '점검결과',
          type: 'textarea',
          placeholder: '안전인력 점검/필요시 개선사항 도출 (문서화)',
          vertical: 'middle',
        },
        {
          id: 'input4',
          title: '조치사항',
          type: 'textarea',
          placeholder: '입력필드',
          vertical: 'middle',
        },
        {
          id: 'input5',
          title: '점검일시',
          type: 'dateArr',
          vertical: 'middle',
        },
        {
          id: 'input6',
          title: '점검결과',
          type: 'textarea',
          placeholder: '안전인력 업무점검 (문서화)',
          vertical: 'middle',
        },
        {
          id: 'input7',
          title: '조치사항',
          type: 'textarea',
          placeholder: '입력필드',
          vertical: 'middle',
        },
      ]"
      v-model="form.table"
    >
      <template #doubleHead>
        <th colspan="2" class="text-center" style="width:34%">구분</th>
        <th colspan="3" class="text-center">상반기</th>
        <th colspan="3" class="text-center">하반기</th>
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        table: [
          {
            label: "1. 필요한 안전인력 확보",
            input1: `① 시설·설비 안전조치 업무<br/>② 시설·설비 유지보수 업무`,
            input2: {},
            input5: {},
          },
          {
            label: "2. 필요한 안전예산 편성·집행",
            input1: `① 인건비<br/>② 시설·장비 확보유지관리비<br/>③ 안전점검비<br/>④ 기타비용`,
            input2: {},
            input5: {},
          },
          {
            label: "3. 안전점검계획 수립·수행",
            input1: `① 정기안전점검<br/>② 정밀안전점검<br/>③ 정밀안전진단`,
            input2: {},
            input5: {},
          },
          {
            label: "4. 안전계획 수립·수행",
            input1: `① 인력확보<br/>② 안전점검 등<br/>③ 유지관리<br/>④ 안전예산 편성`,
            input2: {},
            input5: {},
          },
          {
            label: "5. 재해예방 업무처리 절차 마련·이행",
            input1: `① 정기안전점검<br/>② 정밀안전점검<br/>③ 정밀안전진단`,
            input2: {},
            input5: {},
          },
          {
            label: "6. 도급·용역·위탁 기준과 절차 마련·이행",
            input1: `① 재해예방능력 평기기준·절차<br/>② 비상대피훈련`,
            input2: {},
            input5: {},
          },
          {
            label: "7. 안전·보건 관계 법령 의무이행 점검",
            input1: `① 의무이행사항 점검<br/>② 미이행 시 조치`,
            input2: {},
            input5: {},
          },
          {
            label: "8. 안전관리자/종사자교육 시행 점검",
            input1: `① 교육이수점검<br/>② 미이수 시 조치`,
            input2: {},
            input5: {},
          },
        ],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
